/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-parent[_ngcontent-%COMP%] {\n  background: #EEF1F5;\n  border-top: 1px solid #777;\n  padding-top: 30px;\n  padding-bottom: 30px; }\n\n.form-label-group[_ngcontent-%COMP%], .multiSelect-label-group[_ngcontent-%COMP%], .dropdown-label-group[_ngcontent-%COMP%] {\n  margin-bottom: 1em; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.scss.shim.ngstyle.js.pre-build-optimizer.js